"use strict";

exports.__esModule = true;
exports.default = void 0;
var _error = require("@apollo/client/link/error");
var _sentry = require("../sentry");
// 401s should not happen courtesy of our token refresh solution
// Always log 500s
var CHECK_ERRORS = [401, 500];
var errorLink = (0, _error.onError)(function (errors) {
  var graphQLErrors = errors.graphQLErrors,
    networkError = errors.networkError,
    operation = errors.operation;
  var sentryOptions = {
    extra: {
      operationName: operation.operationName,
      variables: operation.variables
    }
  };
  if (graphQLErrors) {
    graphQLErrors.forEach(function (err) {
      if (err instanceof Error) {
        (0, _sentry.captureException)(err, sentryOptions);
        return;
      }
      if (err.data && err.data.statusCode && CHECK_ERRORS.includes(err.data.statusCode)) {
        (0, _sentry.captureException)(new Error(err.message), sentryOptions);
      }
    });
  }
  if (networkError) {
    (0, _sentry.captureException)(networkError, sentryOptions);
  }
  if (!graphQLErrors && !networkError) {
    (0, _sentry.captureException)(errors);
  }
});
var _default = exports.default = errorLink;